import {
  Component,
  contentChild,
  ElementRef,
  input,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorRequiredComponent } from '../errors/error-required/error-required';
import { ErrorMinComponent } from '../errors/error-min/error-min';
import { Select } from 'primeng/select';

@Component({
  standalone: true,
  selector: 'app-dropdown',
  imports: [
    ReactiveFormsModule,
    ErrorRequiredComponent,
    ErrorMinComponent,
    Select,
  ],
  templateUrl: './dropdown.html',
  styleUrl: './dropdown.scss',
})
export class DropdownComponent {
  /** I/O */
  formCtrl = input.required<FormControl>();
  optionLabel = input<string>();
  optionValue = input<string>();
  options = input<any[]>([]);
  ctrlDataKey = input<string>();
  formCtrlId = input.required<string>();
  ctrlTooltip = input<string>('');
  showLabel = input<boolean>(true);
  showEmptyLabel = input<boolean>(false);
  ctrlPlaceholder = input<string>('');
  ctrlTooltipPosition = input<string>('');
  canFilter = input<boolean>(false);
  ctrlFilterPlaceholder = input<string>('');
  ctrlEmptyMessage = input<string>('Nema opcija');
  ctrlFilterBy = input<string>('');
  ctrlStyleClass = input<string>('');
  ctrlItemStyleClass = input<string>('');
  isGrouped = input<boolean>(false);
  canClear = input<boolean>(false);
  ctrlDisabled = input<boolean>(false);
  hideErrors = input<boolean>(false);
  hasIcon = input<boolean>(false);
  ctrlAppendTo = input<string>('body');
  isEditable = input<boolean>(false);
  pressEnterOnBlur = input<boolean>(false);

  optionChanged = output<any>();

  item = contentChild<TemplateRef<ElementRef>>('item');
  selectedItem = contentChild<TemplateRef<ElementRef>>('selectedItem');

  dropdownElement = viewChild<Select>('dropdownElement');

  handleOnItemChange(event: any) {
    this.optionChanged.emit(event);
  }

  handleEnterOnBlur() {
    if (!this.pressEnterOnBlur()) {
      return;
    }

    const dropdown = this.dropdownElement();
    const item = this.options()[dropdown!.focusedOptionIndex()];

    if (item) {
      this.formCtrl().patchValue(item);
    }
  }
}

export interface DropdownOptions {
  label: string;
  value: any;
}
